import { useEffect } from 'react';
import { federatedSignIn } from '../utils/amplifyAuthHelpers';

export const XeroAuth = () => {
  useEffect(() => {
    federatedSignIn({ customProvider: 'Xero' });
  }, []);
  return null;
};
